import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetLocation, successGetLocation } from './LocationSlicer';
import { ILocationList } from '../../../Pages/Location/ILocation';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddLocation, successAddLocation } from './AddLocationSlicer';
import {
  failureUpdateLocation,
  successUpdateLocation,
} from './UpdateLocationSlicer';
import {
  failureDeleteLocation,
  successDeleteLocation,
} from './DeleteLocationSlice';
import {
  failureGetOneLocation,
  successGetOneLocation,
} from './GetOneLocationSlicer copy';
import { failureGetAds, successGetAds } from './GetAdsSlicer';

const LocationApi = () => {
  return api.get('/location');
};

export function* LocationCall() {
  try {
    const response: AxiosResponse = yield call(LocationApi);
    yield put(successGetLocation(response.data));
  } catch (error) {
    yield put(failureGetLocation(error));
  }
}

// add Location
const AddLocationApi = (action: PayloadAction<ILocationList>) => {
  console.log(action.payload);

  return api.post('/location/create', action.payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* AddLocationCall(action: PayloadAction<ILocationList>) {
  try {
    const response: AxiosResponse = yield call(AddLocationApi, action);
    yield put(successAddLocation(response.data));
  } catch (error) {
    yield put(failureAddLocation(error));
  }
}

// update Location
const UpdateLocationApi = (action: PayloadAction<ILocationList>) => {
  const payload: any = action.payload;

  if (payload?.billing_settings_only) {
    const billingUrl = `/location/billing-settings/${payload.location_id}`;
    return api.patch(billingUrl, {
      minimum_billing_time_unit: payload.minimum_billing_time_unit,
      grace_time: payload.grace_time,
    });
  }

  const id = localStorage.getItem('location');

  const url = `/location/${id}`;

  return api.patch(url, action.payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* UpdateLocationCall(action: PayloadAction<ILocationList>) {
  try {
    const response: AxiosResponse = yield call(UpdateLocationApi, action);
    yield put(successUpdateLocation(response.data));
  } catch (error) {
    yield put(failureUpdateLocation(error));
  }
}

// delete Location
const DeleteLocationApi = (action: PayloadAction<number>) => {
  return api.delete(`/location/${action.payload}`);
};
export function* DeleteLocationCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteLocationApi, action);
    yield put(successDeleteLocation(response.data));
  } catch (error) {
    yield put(failureDeleteLocation(error));
  }
}

const GetLocationApi = (action: PayloadAction<number>) => {
  return api.get(`/location/${action.payload}`);
};
export function* GetLocationCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(GetLocationApi, action);
    yield put(successGetOneLocation(response.data));
  } catch (error) {
    yield put(failureGetOneLocation(error));
  }
}

const GetAdsApi = (action: PayloadAction<number>) => {
  return api.get(`/location/ads/${action.payload}`);
};
export function* GetAdsCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(GetAdsApi, action);
    yield put(successGetAds(response.data));
  } catch (error) {
    yield put(failureGetAds(error));
  }
}